const _salt = '_af0@U#z'

const transactionStatuses = {
    created: 0,
    paid: 1,
    cancelled: 2
}

const cycles = [
    { text: 'неделя', value: 1 },
    { text: 'месяц', value: 2 },
    { text: 'год', value: 3 }
]

const basicPlanId = process.env.DEFAULT_PLAN_ID || 1

const months = [
    'янв.',
    'февр.',
    'мар.',
    'апр.',
    'мая',
    'июня',
    'июля',
    'авг.',
    'сент.',
    'окт.',
    'нояб.',
    'дек.'
]

// const opp = 2
const opp = process.env.OBJECTS_PER_PAGE || 10

function stringToTs(dateString) {
    if(typeof dateString === 'string') {
        let dateParts = dateString.split('-'),
            date

        date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2])
    
        return date.getTime()/1000
    } else if (typeof dateString === 'object') {
        return dateString.getTime()/1000
    } else {
        return false
    }
}

function tsToString(ts) {
    if(isNaN(ts)) return false

    let date = new Date(ts * 1000)
    return `${date.getFullYear()}-${('0'+(date.getMonth()+1)).slice(-2)}-${('0'+date.getDate()).slice(-2)}`
}

function tsToHuman(ts) {
    if(isNaN(ts)) return false

    let date = new Date(ts * 1000)
    let tz = process.env.DISPLAY_TIMEZONE || 'Asia/Almaty'
    try {
        return date.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: 'numeric', timeZone: tz })
    } catch(e) {
        return `${('0'+date.getDate()).slice(-2)} ${months[date.getMonth()]} ${date.getFullYear()}`
    }
}

function getNextMonthSameDay(date) {
    const nextMonth = new Date(date)
    nextMonth.setMonth(nextMonth.getMonth() + 1)
    
    if (nextMonth.getDate() !== date.getDate()) {
        nextMonth.setDate(0)
    }
    
    return nextMonth
}

/**
 * 
 * @param {Date} date date to add to (new Date object)
 * @param {number} cycle period of time (1 - week, 2 - month, 3 - year)
 * @returns Date with the cycle period added
 */

function getNextDate(date, cycle) {
    let nextDate = new Date(date)
    if(cycle == 1) nextDate = new Date(nextDate.getTime() + (7 * 24 * 60 * 60 * 1000))
    if(cycle == 2) nextDate.setMonth(nextDate.getMonth() + 1)
    if(cycle == 3) nextDate.setFullYear(nextDate.getFullYear() + 1)
    
    if(nextDate.getDate() !== date.getDate() && cycle !== 1) {
        nextDate.setDate(0)
    }
    
    return nextDate
}

// function tsToString(ts) {
//     if(isNaN(ts)) return false

//     let date = new Date(ts * 1000)
//     return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} г.`
// }

export { basicPlanId, cycles, opp, _salt, transactionStatuses, getNextDate, getNextMonthSameDay, stringToTs, tsToHuman, tsToString }